import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ep-two-one',
  templateUrl: './ep-two-one.component.html',
  styleUrls: ['./ep-two-one.component.scss']
})
export class EpTwoOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
